import { Heart, MapPin, Star } from "lucide-react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useApp } from "@/context/AppContext";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

export const PropertyCard = ({ property, index = 0 }) => {
  const { formatPrice, t, tr } = useApp();
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const detailUrl = `/hebergement/${property.id}${location.search}`;
  const favorite = async (e) => {
    e.preventDefault();
    if (!user) return navigate("/login");
    const { data } = await api.post(`/favorites/${property.id}?toggle=true`);
    toast.success(data.favorite ? tr("Ajouté aux favoris","Added to favourites","Añadido a favoritos") : tr("Retiré des favoris","Removed from favourites","Eliminado de favoritos"));
  };
  return <article className="property-card reveal" style={{ animationDelay: `${index * 70}ms` }} data-testid={`property-card-${property.id}`}>
      <div className="property-image"><Link to={detailUrl} data-testid={`property-image-link-${property.id}`}><img src={property.image} alt={property.title} loading="lazy" decoding="async"/></Link><span className="verified-badge">{tr("Sélection YAYA","YAYA selection","Selección YAYA")}</span><button onClick={favorite} aria-label={tr("Ajouter aux favoris","Add to favourites","Añadir a favoritos")} data-testid={`favorite-button-${property.id}`}><Heart/></button></div>
      <Link className="property-body" to={detailUrl} data-testid={`property-link-${property.id}`}><div className="property-topline"><span><MapPin/> {property.neighborhood}, {property.city}</span><strong><Star fill="currentColor"/> {property.rating || "Nouveau"}</strong></div>
        <h3 data-testid={`property-title-${property.id}`}>{property.title}</h3>
        <p>{property.category} · {property.bedrooms} {tr("chambre(s)","bedroom(s)","habitación(es)")} · {property.guests} {tr("voyageurs","guests","viajeros")}</p>
        <div className="price-line"><strong data-testid={`property-price-${property.id}`}>{formatPrice(property.price_eur)}</strong><span> / {t.night}</span></div>
      </Link>
  </article>;
};